/**
 * Способы выплаты, доступные через терминал.
 *
 * Бэкенд отдаёт их в `payoutMethods` каждого терминала (`GET /merchant/{uuid}`).
 * Список считается по настройкам терминала: флаг «терминал под СБП», типы
 * заявок CRM и протокол процессинга — выплату по СБП умеют не все.
 *
 * Зачем это на фронте: кабинет метода терминала не знал вовсе и в карточном
 * реестре предлагал в том числе СБП-терминалы. Мерчант выбирал «arMax Тест —
 * выплаты по СБП», а страница просила у него номера карт — при том, что через
 * этот терминал платят по номеру телефона. Проверка на бэкенде такой файл
 * отобьёт, но уже после того, как человек его собрал и загрузил.
 */

export const PAYOUT_METHOD_CARD = "card";
export const PAYOUT_METHOD_SBP = "sbp";

/**
 * Доступен ли способ выплаты через этот терминал.
 *
 * Пустой или отсутствующий `payoutMethods` означает «не знаем» и пропускает
 * терминал: кабинет и бэкенд выкатываются порознь, и пока поле не приехало,
 * скрывать терминалы нельзя — мерчант останется без списка вообще.
 *
 * @param {object|null} terminal
 * @param {string} method PAYOUT_METHOD_CARD | PAYOUT_METHOD_SBP
 * @returns {boolean}
 */
export function terminalSupportsMethod(terminal, method) {
    if (!terminal) {
        return false;
    }

    const methods = terminal.payoutMethods;
    if (!Array.isArray(methods) || methods.length === 0) {
        return true;
    }

    const wanted = String(method).toLowerCase();

    return methods.some((m) => String(m).toLowerCase() === wanted);
}

/**
 * Терминалы, через которые можно выплатить этим способом.
 *
 * @param {Array|null} terminals
 * @param {string} method PAYOUT_METHOD_CARD | PAYOUT_METHOD_SBP
 * @returns {Array}
 */
export function filterTerminalsByMethod(terminals, method) {
    if (!Array.isArray(terminals)) {
        return [];
    }

    return terminals.filter((t) => terminalSupportsMethod(t, method));
}



// WEBPACK FOOTER //
// ./src/Services/payoutMethods.js